const consolidatedTrendAnalysisTemplate = (() => {
    const main = {
        "1": {
            "config": {
                "class": "container"
            },
            "tag": "div",
            "parent": -1
        },
        "2": {
            "config": {
                "class": "monthly-summery"
            },
            "tag": "div",
            "parent": 1
        },
        "3": {
            "config": {
                "class": "row pt-3"
            },
            "tag": "div",
            "parent": 2
        },
        "4": {
            "config": {
                "class": "col-3"
            },
            "tag": "div",
            "parent": 3
        },
        "5": {
            "config": {
                "class": "pb-0"
            },
            "tag": "h4",
            "parent": 4,
            "html": "Trend Analysis"
        },
        "6": {
            "config": {},
            "tag": "form",
            "parent": 2
        },
        "7": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 6
        },
        "8": {
            "config": {
                "class": "col-4 pt-5"
            },
            "tag": "div",
            "parent": 7
        },
        "9": {
            "config": {
                "class": "input-group mb-2"
            },
            "tag": "div",
            "parent": 8
        },
        "10": {
            "config": {
                "class": "pt-3",
                "for": "accountLevel"
            },
            "tag": "label",
            "parent": 9,
            "html": "Account Level"
        },
        "11": {
            "config": {
                "class": "custom-select ml-3 input-lg accountNumberConsolidatedTrendAnalysisFilter",
                "id": "accountNumberConsolidatedTrendAnalysis"
            },
            "tag": "select",
            "parent": 9,
            "events": [
                {
                    "id": "accountNumberConsolidatedTrendAnalysis",
                    "name": "change",
                    "callback": "getAccountNumberConsolidatedTrendAnalysisSelectedValue"
                }
            ]
        },
        "16": {
            "config": {
                "class": "col-6 pt-3 offset-md-2"
            },
            "tag": "div",
            "parent": 7
        },
        "17": {
            "config": {
                "class": "input-group mb-2"
            },
            "tag": "div",
            "parent": 16
        },
        "18": {
            "config": {
                "class": "pt-5",
                "for": "seelctvar1"
            },
            "tag": "label",
            "parent": 17,
            "html": "Select"
        },
        "19": {
            "config": {
                "class": "col"
            },
            "tag": "div",
            "parent": 17
        },
        "20": {
            "config": {
                "class": "pt-2 font-r",
                "for": "seelctvar1"
            },
            "tag": "label",
            "parent": 19,
            "html": "Variable 1"
        },
        "21": {
            "config": {
                "class": "custom-select input-lg select1ConsolidatedTrendAnalysisFilter",
                "id": "select1ConsolidatedTrendAnalysis"
            },
            "tag": "select",
            "parent": 19,
            "events": [
                {
                    "id": "select1ConsolidatedTrendAnalysis",
                    "name": "change",
                    "callback": "select1ConsolidatedTrendAnalysisSelectedValue"
                }
            ]
        },
        "26": {
            "config": {
                "class": "col"
            },
            "tag": "div",
            "parent": 17
        },
        "27": {
            "config": {
                "class": "pt-2 font-r",
                "for": "seelctvar2"
            },
            "tag": "label",
            "parent": 26,
            "html": "Variable 2"
        },
        "28": {
            "config": {
                "class": "custom-select input-lg select2ConsolidatedTrendAnalysisFilter",
                "id": "select2ConsolidatedTrendAnalysis"
            },
            "tag": "select",
            "parent": 26,
            "events": [
                {
                    "id": "select2ConsolidatedTrendAnalysis",
                    "name": "change",
                    "callback": "select2ConsolidatedTrendAnalysisSelectedValue"
                }
            ]
        },
        "33": {
            "config": {
                "class": "payment-graph mt-3 hideShowSection1"
            },
            "tag": "div",
            "parent": 1
        },
        "34": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 33
        },
        "35": {
            "config": {
                "class": "col-12"
            },
            "tag": "div",
            "parent": 34
        },
        "36": {
            "config": {
                "class": "card p-3 pt-4"
            },
            "tag": "div",
            "parent": 35
        },
        "37": {
            "config": {
                "class": "card-body p-0 pt-3 text-center"
            },
            "tag": "div",
            "parent": 36
        },
        "38": {
            "config": {
                "class": "graph trend-analysis-graph"
            },
            "tag": "div",
            "parent": 37
        },
        "40": {
            "config": {
                "class": "card-body pr-2"
            },
            "tag": "div",
            "parent": 37
        },
        "41": {
            "config": {
                "class": "row text-left"
            },
            "tag": "div",
            "parent": 40
        },
        "42": {
            "config": {
                "class": "col-6"
            },
            "tag": "div",
            "parent": 41
        },
        "43": {
            "config": {
                "class": "card-footer revenue revPercent bluegradient p-0 mHt100"
            },
            "tag": "div",
            "parent": 42
        },
        "44": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 43
        },
        "45": {
            "config": {
                "class": "col-3 text-center"
            },
            "tag": "div",
            "parent": 44
        },
        "46": {
            "config": {
                "class": "percent",
                "id": "left-percent"
            },
            "tag": "span",
            "parent": 45,
            "html": "N/A",
        },
        "47": {
            "config": {
                "class": "col-7 p-0"
            },
            "tag": "div",
            "parent": 44
        },
        "48": {
            "config": {
                "id": "left-heading"
            },
            "tag": "h6",
            "parent": 47,
            "html": "Variable 1 : Revenue",
        },
        "49": {
            "config": {
                "id": "left-description"
            },
            "tag": "p",
            "parent": 47,
            "html": "Last 2 Months Revenue / Annualized Revenue",
        },
        "50": {
            "config": {
                "class": "col-2 pr-0 pt-2"
            },
            "tag": "div",
            "parent": 44
        },
        "51": {
            "config": {
                "class": "theme-switch m-0",
                "for": "veriable1"
            },
            "tag": "label",
            "parent": 50
        },
        "52": {
            "config": {
                "class": "sr-only"
            },
            "tag": "span",
            "parent": 51,
            "html": "veriable11"
        },
        "53": {
            "config": {
                "type": "checkbox",
                "checked": "",
                "id": "veriable1"
            },
            "tag": "input",
            "parent": 51,
            "html": "",
            "events": [
                {
                    "id": "veriable1",
                    "name": "change",
                    "callback": "showVariableChart1"
                }
            ]
        },
        "54": {
            "config": {
                "class": "slider round"
            },
            "tag": "span",
            "parent": 51,
            "html": ""
        },
        "55": {
            "config": {
                "class": "col-6"
            },
            "tag": "div",
            "parent": 41
        },
        "56": {
            "config": {
                "class": "card-footer revenue revPercent greenGradient p-0 mHt100"
            },
            "tag": "div",
            "parent": 55
        },
        "57": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 56
        },
        "58": {
            "config": {
                "class": "col-3 text-center"
            },
            "tag": "div",
            "parent": 57
        },
        "59": {
            "config": {
                "class": "percent",
                "id": "right-percent"
            },
            "tag": "span",
            "parent": 58,
            "html": "N/A",
        },
        "60": {
            "config": {
                "class": "col-7 p-0"
            },
            "tag": "div",
            "parent": 57
        },
        "61": {
            "config": {
                "id": "right-heading"
            },
            "tag": "h6",
            "parent": 60,
            "html": "Variable 2 : Expense",
        },
        "62": {
            "config": {
                "id": "right-description"
            },
            "tag": "p",
            "parent": 60,
            "html": "Last 2 Months Expense / Annualized Expense",
        },
        "63": {
            "config": {
                "class": "col-2 pt-2 pr-0"
            },
            "tag": "div",
            "parent": 57
        },
        "64": {
            "config": {
                "class": "theme-switch m-0",
                "for": "veriable2"
            },
            "tag": "label",
            "parent": 63
        },
        "65": {
            "config": {
                "class": "sr-only"
            },
            "tag": "span",
            "parent": 64,
            "html": "veriable11"
        },
        "66": {
            "config": {
                "type": "checkbox",
                "checked": "",
                "id": "veriable2"
            },
            "tag": "input",
            "parent": 64,
            "html": "",
            "events": [
                {
                    "id": "veriable2",
                    "name": "change",
                    "callback": "showVariableChart2"
                }
            ]
        },
        "67": {
            "config": {
                "class": "slider round"
            },
            "tag": "span",
            "parent": 64,
            "html": ""
        },
        "69": {
            "config": {
                "id": "tableview",
                "class": "listStatement card p-0 hideShowSection2"
            },
            "tag": "div",
            "parent": 1
        },
        "70": {
            "config": {
                "class": "data-wrap-fixed row m-0"
            },
            "tag": "div",
            "parent": 69
        },
        "71": {
            "config": {
                "class": "col-1 p-0 dataLeft-fixed firstcol dataLeftFixedConsolidatedTrendAnalysis"
            },
            "tag": "div",
            "parent": 70
        },
        "72": {
            "config": {
                "class": "col-10 p-0"
            },
            "tag": "div",
            "parent": 70
        },
        "73": {
            "config": {
                "class": "mid-panel midPanelConsolidatedTrendAnalysis"
            },
            "tag": "div",
            "parent": 72
        },
        "74": {
            "config": {
                "class": "data-head midPanelDataHeadConsolidatedTrendAnalysis"
            },
            "tag": "div",
            "parent": 73
        },
        "75": {
            "config": {
                "class": "col-1 dataRight-fixed p-0 dataRightFixedConsolidatedTrendAnalysis"
            },
            "tag": "div",
            "parent": 70
        },
        "39": {
            "config": {
                "class": "graph trend_analysis_variables_graph row"
            },
            "tag": "div",
            "parent": 37
        },
        "86": {
            "config": {
                "class": "col-6"
            },
            "tag": "div",
            "parent": 39
        },
        "87": {
            "config": {
                "class": "col-6"
            },
            "tag": "div",
            "parent": 39
        },
        "88": {
            "config": {
                "id": "heading_variable1"
            },
            "tag": "h4",
            "html": "Revenue",
            "parent": 86
        },
        "89": {
            "config": {
                "id": "heading_variable2"
            },
            "tag": "h4",
            "html": "Operating Expense",
            "parent": 87
        },
        "90": {
            "config": {
                "id": "graph_variable1"
            },
            "tag": "div",
            "html": "No Data",
            "parent": 86
        },
        "91": {
            "config": {
                "id": "graph_variable2"
            },
            "tag": "div",
            "html": "No Data",
            "parent": 87
        }
    };

    return {
        main
    };
})();
